
// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase config (replace <dummy> with actual key)
const firebaseConfig = {
  apiKey: "AIzaSyB89_8qZXkbQht7gkQkbW1soxGEy_mve_Q",
  authDomain: "infragenie-e157f.firebaseapp.com",
  projectId: "infragenie-e157f",
  storageBucket: "infragenie-e157f.appspot.com",
  messagingSenderId: "723652446735",
  appId: "1:723652446735:web:cdb710bf4fd8c2c1dc317a",
  measurementId: "G-6Q0BKQ0V3L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Only export once (no reinitializing above)
export const auth = getAuth(app);
export const db = getFirestore(app);

// Optional: debug check
console.log("Firebase config being used:", firebaseConfig);

